module.exports = __webpack_public_path__ + "media/src/assets/images/booking-details/guests-c8e850b9aa4102e7e1b1fc0586ba28d4.png";